import { useState, useEffect, useCallback } from "react";
import { DdSettings } from "../api";
import { useCompany } from "../contexts/CompanyContext";

const ddSettingsApi = new DdSettings();

export const METHODOLOGIES = {
  fla:  { label: "FLA Workplace Code", home: "/admin/fla-assessment?v=assess" },
  ocde: { label: "Guía OCDE 2021",     home: "/admin/ocde-guide" },
};

// Caché compartida entre componentes (DDNav, menú, Inicio) para no volver a
// pedirla en cada página ni mostrar la metodología equivocada mientras carga.
let cache = { key: null, value: undefined };
const listeners = new Set();

/**
 * Metodología elegida por la empresa ("fla" | "ocde" | null = sin elegir).
 * Al elegir, la otra metodología se oculta del menú y del Inicio (spec v8).
 */
export function useDdMethodology(accessToken) {
  const { company } = useCompany();
  const key = company || "";
  const [methodology, setMethodology] = useState(cache.key === key ? cache.value : undefined);

  useEffect(() => {
    listeners.add(setMethodology);
    return () => { listeners.delete(setMethodology); };
  }, []);

  useEffect(() => {
    if (!accessToken) return;
    if (cache.key === key && cache.value !== undefined) { setMethodology(cache.value); return; }
    let alive = true;
    ddSettingsApi.getData(accessToken)
      .then((d) => {
        const v = METHODOLOGIES[d?.methodology] ? d.methodology : null;
        cache = { key, value: v };
        if (alive) setMethodology(v);
      })
      .catch((err) => {
        console.error("Error cargando la metodología elegida", err);
        if (alive) setMethodology(null);
      });
    return () => { alive = false; };
  }, [accessToken, key]);

  const chooseMethodology = useCallback((value) => {
    cache = { key, value };
    listeners.forEach((l) => l(value));
    if (accessToken) {
      ddSettingsApi.saveData(accessToken, { methodology: value })
        .catch((err) => console.error("Error guardando la metodología elegida", err));
    }
  }, [accessToken, key]);

  return {
    methodology: methodology ?? null,
    methodologyLoading: methodology === undefined,
    chooseMethodology,
  };
}
